import { getSession } from './api'

export function openTrackersCommonDashboard() {
  const url = new URL('trackers-common-dashboard.html?source=taskops', new URL(import.meta.env.BASE_URL, window.location.origin))
  const child = window.open(url.href, '_blank')
  if (!child) { window.alert('Allow this site to open the dashboard in a new tab.'); return }
  const origin = window.location.origin
  const handler = async (event: MessageEvent) => {
    if (event.origin !== origin || event.source !== child || event.data?.type !== 'trackers-token-request' || typeof event.data.requestId !== 'string' || event.data.requestId.length > 100) return
    try {
      const session = await getSession()
      if (!session) throw new Error('Sign in again in the original TaskOps tab.')
      child.postMessage({ type: 'trackers-session', requestId: event.data.requestId, access_token: session.access_token }, origin)
    } catch {
      child.postMessage({ type: 'trackers-session', requestId: event.data.requestId, error: 'Your TaskOps session has expired. Sign in again in the original tab.' }, origin)
    }
  }
  window.addEventListener('message', handler)
  const timer = window.setInterval(() => {
    if (child.closed) { window.removeEventListener('message', handler); window.clearInterval(timer) }
  }, 2000)
}
